import React from 'react';

function Icon() {
  return (
    <svg width="95" height="95" fill="none" viewBox="0 0 95 95">
      <path
        fill="#4783FF"
        d="M65.756 82.678l-12.06-19.263a2.763 2.763 0 01-.278-2.336 2.762 2.762 0 011.619-1.71c6.777-2.649 12.6-5.635 19.012-11.588a2.776 2.776 0 013.293-.356 2.75 2.75 0 011.279 3.057l-7.83 31.4a2.763 2.763 0 01-2.255 2.062 2.765 2.765 0 01-2.78-1.266z"></path>
      <path
        fill="#7EA8FF"
        d="M10.514 25.922a2.766 2.766 0 012.072-2.256l31.437-7.793a2.78 2.78 0 013.053 1.283 2.777 2.777 0 01-.353 3.298c-5.953 6.412-8.94 12.235-11.587 19.013a2.77 2.77 0 01-1.714 1.62 2.769 2.769 0 01-2.341-.28L11.779 28.709a2.769 2.769 0 01-1.265-2.787z"></path>
      <path
        fill="#B5CDFF"
        d="M79.85 49.888c-7.283 7.283-13.584 11.02-22.787 14.643-3.69 1.444-11.73 4.173-16.875 6.07-1.018.39-2.114.156-2.897-.628L24.527 57.21c-.784-.783-1.018-1.879-.627-2.897 1.895-5.143 4.536-12.958 6.07-16.875 3.566-9.061 7.286-15.431 14.642-22.787 4.934-4.933 10.924-8.261 16.993-10.415L79.85 14.65l10.415 18.245c-2.154 6.069-5.481 12.06-10.415 16.993z"></path>
      <path
        fill="url(#paint0_linear_start_up)"
        d="M.81 93.69a2.77 2.77 0 01-.764-2.463c.614-3.344 6.602-22.96 11.282-27.64 5.4-5.398 14.186-5.398 19.585 0 5.398 5.4 5.398 14.186 0 19.585-4.68 4.68-24.296 10.668-27.64 11.282A2.769 2.769 0 01.81 93.69z"></path>
      <path
        fill="url(#paint1_linear_start_up)"
        d="M52.443 42.057c-4.317-4.317-4.319-11.343 0-15.661 4.319-4.32 11.344-4.317 15.661 0 4.317 4.316 4.319 11.342 0 15.661-4.319 4.319-11.344 4.317-15.661 0z"></path>
      <path
        fill="url(#paint2_linear_start_up)"
        d="M94.337 2.669A2.696 2.696 0 0091.831.163C90.97.085 76.17-1.09 61.605 4.235l28.66 28.66C95.59 18.33 94.415 3.53 94.337 2.669z"></path>
      <defs>
        <linearGradient id="paint0_linear_start_up" x1="28.5" x2="-11.5" y1="68" y2="95" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7EA8FF"></stop>
          <stop offset="1" stopColor="#7EA8FF" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_start_up"
          x1="60.273"
          x2="60"
          y1="23.157"
          y2="57"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#EEF4FF"></stop>
          <stop offset="1" stopColor="#EEF4FF" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient id="paint2_linear_start_up" x1="66" x2="78" y1="-17.5" y2="19.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4783FF"></stop>
          <stop offset="1" stopColor="#7EA8FF"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Icon;
